import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../util_grid/grid';
import PriceBlock from '../../base_price-block/component';
import AddToCartButton from '../../ui_add-to-cart-button/component';
import { TitleAndSubtitle, Rating } from 'audamatic-ui';
import Icon from '../../base_svg-icon/component';
import Link from '../../base_link/component';
import Text from '@text';
import { t } from '@utils/i18n';
import './styles/styles.scss';

class AnkeilerInfoBlock extends PureComponent {
  constructor(props) {
    super(props);
    this.store = this.props.store;
    this.state = {
      expanded: null,
      offsetTop: null,
    };
    this.ref = null;
    this.caretRef = createRef();
    this.descriptionRef = createRef();
    this.isSet = false;
  }

  componentDidMount() {
    window.addEventListener('click', this.checkVisibility);
    window.addEventListener('resize', this.closeInfoBlock);
    this.ref = createRef();
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.checkVisibility);
    window.removeEventListener('resize', this.closeInfoBlock);
  }

  closeInfoBlock = () => {
    this.props.hideBlock();
  };

  checkVisibility = (e) => {
    if (!!this.isSet && !this.ref?.current?.contains(e.target)) {
      this.props.hideBlock();
    }
    this.isSet = true;
  };

  get product() {
    return this.props.product;
  }

  get title() {
    return this.props.title;
  }

  get position() {
    const { parentRef } = this.props;
    const { left } = parentRef.current.ankeilerRef.current.getBoundingClientRect();
    return {
      left: -left,
      top: parentRef.current.anchorRef.current.offsetTop,
    };
  }

  get description() {
    const { longDescription, shortDescription } = this.product;
    return (longDescription || shortDescription);
  }

  /**
   * Check whether or not the description is larger than its container
   * @returns {boolean}
   */
  get descriptionOverflow() {
    if (this.descriptionRef.current) {
      const { clientHeight, scrollHeight } = this.descriptionRef.current;
      return (scrollHeight > clientHeight);
    }
    return false;
  }

  toggleDescription = () => this.setState(prevState => ({ expanded: !prevState.expanded }));

  render() {
    const { rating = 0, url } = this.product;
    const { expanded } = this.state;
    const { info = {} } = this.props;
    const { quickOrder } = info;
    const showMore = (!!quickOrder && !!this.descriptionOverflow) || expanded !== null;

    return (
      <span ref={this.ref}>
        <span className="info-block-caret" ref={this.caretRef} />
        <div className="full-block" style={this.position}>
          <div className="ankeiler-info-block">
            <Row>
              <Col md={4} lg={3}>
                <div className="book-details">
                  <div className="details">
                    <TitleAndSubtitle
                      title={this.title}
                      subtitle={this.product.personsLinks}
                    />
                  </div>
                  {!!rating && (
                    <div className="ankeiler-rating">
                      <Rating rating={rating} />
                    </div>
                  )}
                  <PriceBlock product={this.product} store={this.store} />
                  <AddToCartButton
                    hideIcon
                    store={this.store}
                    product={this.product}
                    quickOrder={quickOrder}
                    showQuantity={true}
                    showOrderlineReference={true}
                  />
                </div>
              </Col>
              <Col md={8} lg={9}>
                <div ref={this.descriptionRef} className={`description ${expanded ? 'expanded' : ''}`}>
                  <div className="text" dangerouslySetInnerHTML={{ __html: this.description }} />
                </div>
                <div
                  className={`info-block-action ${showMore ? 'visible' : ''}`}
                  onClick={this.toggleDescription}
                >
                  <Icon
                    name="ico-arrow-circle-down"
                    className={expanded ? 'rotated' : ''}
                  />
                  <span>{t(expanded ? 'common.link.readless' : 'common.link.readmore')}</span>
                </div>

                {!quickOrder && (
                  <Link className="info-block-action" to={url}>
                    <Icon
                      name="ico-arrow-circle-right"
                    />
                    <span><Text>comp.bookdetails.viewAll</Text></span>
                  </Link>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </span>
    );
  }
}

AnkeilerInfoBlock.propTypes = {
  store: PropTypes.object,
  info: PropTypes.shape({
    quickOrder: PropTypes.bool,
  }),
  hideBlock: PropTypes.func.isRequired,
  parentRef: PropTypes.func,
  product: PropTypes.object,
  title: PropTypes.object,
};

export default AnkeilerInfoBlock;
